import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'

const AuthFormButton = ({ text, }) => {
  const classes = useStyles()
  return (
    <div className={classes.button}>
      <button>
        {text}
      </button>
    </div>
  )
}

AuthFormButton.propTypes = {
  text: PropTypes.string.isRequired,
}

const useStyles = createUseStyles({
  button: {
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: 'column',
    width: '100%',
    marginTop: '0.5em',
    '& button': {
      padding: '9px 49px',
      fontSize: '15px',
      border: '2px solid #57c2ef',
      borderRadius: '5px',
      color: '#57c2ef',
      fontWeight: '700',
      background: 'transparent',
      transition: '200ms all linear',
      cursor: 'pointer',
    },
    '& button:hover': {
      color: 'white',
      backgroundColor: '#57c2ef',
    },
  },
})
export default AuthFormButton
